import React, { useEffect, useState } from "react";
import axios from "axios";
import AcCalendar from "./FullCalender";

const Calendar = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const[email,setEmail]=useState("");
  useEffect(() => {
    // Get the authorization code from the URL
    const code = new URLSearchParams(window.location.search).get("code");

    if (!code) {
      setError("Authorization code is missing.");
      setLoading(false);
      return;
    }

    // Exchange the authorization code for tokens and fetch events
    axios
      .post("https://calenderbackend-seven.vercel.app/auth/google", { code })
      .then((response) => {
        // setEvents(response.data?.events||[]); // Update the event list
        // setLoading(false);
        setEmail(response.data.email);
        getEvents(response.data.email);
      })
      .catch((err) => {
        setError("Failed to fetch calendar events. Try again later.");
        console.error(err);
        setLoading(false);
      });
  }, []);
  const getEvents =  (email) => {
    // get the events
    axios
    .get("https://calenderbackend-seven.vercel.app/calendar/events",{params:{email}})
    .then((response) => {
      setEvents(response.data||[]); // Update the event list
      setLoading(false);
    })
    .catch((err) => {
      setError("Failed to fetch calendar events. Try again later.");
      console.error(err);
      setLoading(false);
    });

  }
  // if (loading) return <p>Loading...</p>;
  // if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div style={{ textAlign: "center" }}>{
      loading?<p>Loading...</p>:error?<p style={{ color: "red" }}>{error}</p>:
    
      <>
      <AcCalendar tasks={events} setEvents={setEvents} email={email}/>
      </>}
    </div>
  );
};

export default Calendar;
